import { Badge, Button, Tooltip, WorkflowIcon } from '@/components';
import { useProjectNotificationBadges } from '@/features/project/_hooks/notification';
import { useWorkflowStackSiderView } from '@/features/workflow/hooks/stack-sider-view';
import { useId } from '@/hooks';
import { useStackSiderView } from '@/providers/StackSiderViewProvider';
import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const WorkflowSiderButton: FC<{ name?: string }> = ({ name }) => {
  const { t } = useTranslation();
  const { id } = useId();

  const notification = useProjectNotificationBadges({ id });
  const notificationCount = notification.data?.workflow.actionRequired;

  const stackSiderView = useStackSiderView();
  const workflowStackSiderView = useWorkflowStackSiderView();

  const siderTarget = useMemo(
    () =>
      ({
        id,
        key: 'project',
        name,
      }) as const,
    [id, name],
  );

  const handleClick = () => {
    workflowStackSiderView.push({
      payload: {
        config: {
          viewType: 'workflow-list',
          target: siderTarget,
        },
      },
      target: {
        type: 'project',
        projectId: id,
      },
    });
  };

  return (
    <Tooltip title={t('workflow')}>
      <Badge
        count={notificationCount}
        color="red"
        size="small"
        style={{
          boxShadow: 'none',
          paddingInline: 4,
        }}
        offset={[!!notificationCount && notificationCount < 10 ? -4 : -10, 4]}
      >
        <Button
          onClick={handleClick}
          disabled={stackSiderView.state.stack.length > 0}
          icon={<WorkflowIcon aria-label="" />}
        />
      </Badge>
    </Tooltip>
  );
};
